import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useExpenseCategory, ExpenseCategory } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<ExpenseCategory>
      useData={useExpenseCategory}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
